/* eslint-disable no-useless-escape */ /* eslint-disable */

<template>
  <v-dialog v-model="showDialog" style="background-color: white;" >
    <v-card >
      <v-card-title class="text-h5">Vista previa</v-card-title>
      <v-card-text>
        <div v-if="Body != ''" v-html="Body"></div>
        <div v-else>No hay plantilla para mostrar</div>
        <v-btn class="btn-save" @click="exportHtml">Exportar archivo html</v-btn>
        <!-- <v-row>
          <v-col cols="12" md="12">
            <EmailEditor
              :appearance="appearance"
              :min-height="minHeight"
              :project-id="projectId"
              :display-mode="displayMode"
              :locale="locale"
              :tools="tools"
              :options="options"
              ref="emailEditor"
              v-on:load="editorLoaded"
              v-on:ready="editorReady"
            />
          </v-col>
        </v-row> -->
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="btndelete" @click="closeDialog"> Cerrar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ShowHFDialogue",
  watch: {
    showDialog(val) {
      val || this.closeDialog();
    },
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          Email_Body: "",
        };
      },
    },
  }, // ["data"],
  components: {},
  data() {
    return {
      showDialog: false,
    };
  },
  mounted() {
    console.log(this.data)
  },
  computed: {
    Body() {
      return this.data
        ? this.data.Body?.length > 50
          ? JSON.parse(this.data?.Body).html
          : ""
        : "";
    },
  },
  methods: {
    closeDialog() {
      this.showDialog = false;
      this.$emit("close");
    },
    save(data) {
      let obj = {
        Body: JSON.stringify({ html: data.html, design: data.design }),
        State: "Active",
        Name: "Test1",
        ID_User: "USR2020259",
      };
      this.$API.email
        .addEmail(obj)
        .then((response) => {
          this.$toasted.success(response.message);
          console.log("Done");
        })
        .catch(() => {});
    },
    exportHtml(){}
  },
};
</script>

<style scoped>
.unlayer-editor {
  height: 1000px !important;
}
.unlayer-editor iframe {
  min-width: auto !important;
}
.btn-add{
  background-color: #3498DB  !important;
  color: white;
}
.btnsave{
  background-color: #00A178 !important;
  color: white;
}
.btnclean{
  background-color: #F29D35 !important;
  color: white;
}
.btndelete{
  background-color: #E3191E !important;
  color: white;
}

</style>
